import React from 'react';

import classNames from 'classnames';
import { useSelector } from 'react-redux';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import PaymentDetails from './PaymentDetails';

import { PayWith } from 'components/PaymentMethod/type';
import { usePaymentMethod } from 'components/PaymentMethod/context';

import { enableMultipleCardDeletion } from 'utils/killswitch';
import { remoteConfigSelector } from 'redux/modules/settings/remoteConfig/selectors';
import { getPaymentMethodLabels } from 'redux/modules/dynamicLabels/selectors';

import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/components/paymentMethodsStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

const BOMPaymentList = () => {
	const classes = useStyles();
	const paymentMethodLabels = useSelector(getPaymentMethodLabels);
	const {
		tokens: {
			BOM: { tokens, defaultToken },
		},
		onBankAliasSelect,
		openDeleteConfirmationModal,
	} = usePaymentMethod();

	// kill switch to check if Bank Muscat are to be shown
	const remoteConfig = useSelector(remoteConfigSelector);
	const isMultiCardEnabled = enableMultipleCardDeletion(remoteConfig);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const tokenID = (event.target as HTMLInputElement).value;
		const token = tokens.find((card) => card.id === tokenID);

		if (tokenID && token) onBankAliasSelect(token);
	};

	const selectedToken = defaultToken?.id;

	return (
		<div className={classes.cardWrapper}>
			{tokens?.length === 0 && (
				<div className={classNames(classes.billDetailsContainer, classes.paddingBottomNone)}>
					<h6 className={classes.cardDetailTitle}>{paymentMethodLabels?.no_payment_alias_added}</h6>
				</div>
			)}
			{tokens?.length > 0 && (
				<FormControl component="fieldset" className={classes.introSlide}>
					<RadioGroup
						aria-label="card-payment"
						defaultValue={selectedToken}
						value={selectedToken}
						onChange={handleChange}
						className={classes.introSlide}
						name="cards"
						key={selectedToken}
					>
						{tokens.map((token) => (
							<div
								key={token?.id}
								className={classNames(classNames(classes.cardDetailsContainer, classes.cardItem))}
							>
								<div className={classes.paymentMethodWrapper}>
									<FormControlLabel
										value={token.id}
										className={classes.paymentMethodWrapper}
										control={<Radio size="small" value={token.id} />}
										label={
											<PaymentDetails
												variant="minimal"
												bankAliasID={token.paymentAliasId}
												mobileNumber={token.mobileNumber}
											/>
										}
									/>
								</div>
								{isMultiCardEnabled && (
									<div className={classes.cardChangeActionContainer}>
										<button
											type="button"
											className={classes.deleteAction}
											onClick={() =>
												openDeleteConfirmationModal(
													token.id,
													PayWith.BM,
													token?.isUnSaved ?? false
												)
											}
										>
											{paymentMethodLabels?.delete}
										</button>
									</div>
								)}
							</div>
						))}
					</RadioGroup>
				</FormControl>
			)}
		</div>
	);
};

export default BOMPaymentList;
